/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Enable_Confirm_ExistingInputs */



/**
* | output |
* | --- |
* | "Existing chats become private right away, together with their files and AI-created documents. Older files and documents from chats, made before this feature ..." |
*
* @param {Project_Private_Chats_Enable_Confirm_ExistingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_enable_confirm_existing = /** @type {((inputs?: Project_Private_Chats_Enable_Confirm_ExistingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Enable_Confirm_ExistingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestehende Chats werden sofort privat, samt ihren Dateien und KI-erstellten Dokumenten. Ältere Dateien und Dokumente aus Chats, die entstanden sind, bevor es diese Funktion gab, bleiben für alle Mitglieder sichtbar.")
	return /** @type {LocalizedString} */ ("Existing chats become private right away, together with their files and AI-created documents. Older files and documents from chats, made before this feature existed, stay visible to all members.")
});